module.exports = __webpack_public_path__ + "assets/img/aboutUS-module1-4.14d71ec0.jpg";